import { render, staticRenderFns } from "./FormShare.vue?vue&type=template&id=50628b8c&"
import script from "./FormShare.vue?vue&type=script&lang=js&"
export * from "./FormShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports